import React, { useEffect, useRef } from 'react';
import classNames from 'classnames';
import type { M_Select } from '../types';
import positionHandler from './positionHandler';

interface Props {
  options: M_Select.item[];
  target: HTMLElement;
  selected: M_Select.item | null;
  onChangeHandler: (item: M_Select.item) => void;
  position: 'bottom' | 'top';
}
const Options: React.FC<Props> = ({ options, target, selected, onChangeHandler, position }): JSX.Element => {
  const containerRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (containerRef.current) {
      positionHandler({ position, target, selectRoot: containerRef.current });
    }
  }, [containerRef]);

  return (
    <div ref={containerRef} className="jack__select__options">
      {options.map((item: M_Select.item, index): JSX.Element => {
        const { value, disabled = false } = item;
        const active = selected?.value === value;
        return (
          <div
            key={index}
            className={classNames('jack__select__item', { active, disabled })}
            onClick={(): void => {
              if (!item.disabled) onChangeHandler(item);
            }}
          >
            {item.title}
          </div>
        );
      })}
    </div>
  );
};

export default Options;
